module.exports = __webpack_public_path__ + "img/nav-logo.591e4b70.svg";